module.exports = __webpack_public_path__ + "static/media/Slice5@2x.d72a65ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice5@2x.png
// module id = 1430
// module chunks = 0